import React from 'react';
import { Link } from 'react-router-dom';
import styles from './VRCLanding.module.css';

const VRCLanding = () => {
  return (
    <div className={styles.container}>
      <div className={styles.hero}>
        <div className={styles.badge}>VRC PRO</div>
        <h1 className={styles.title}>Valor Real Competitivo</h1>
        <p className={styles.subtitle}>
          Calculá el valor de mercado de un inmueble mediante la comparación con propiedades similares,
          aplicando coeficientes de ajuste profesionales.
        </p>
      </div>

      <div className={styles.cards}>
        <Link to="/vrc-nuevo" className={styles.card}>
          <div className={styles.cardIcon}>🏠</div>
          <h2 className={styles.cardTitle}>Nuevo VRC</h2>
          <p className={styles.cardDesc}>
            Creá un informe de tasación profesional con comparables y cálculo automático del VRC.
          </p>
          <span className={styles.cardBtn}>Comenzar →</span>
        </Link>

        <Link to="/vrc-lista" className={styles.card + ' ' + styles.cardSecondary}>
          <div className={styles.cardIcon}>📋</div>
          <h2 className={styles.cardTitle}>Mis VRCs</h2>
          <p className={styles.cardDesc}>
            Consultá, editá y descargá todos los informes VRC que creaste anteriormente.
          </p>
          <span className={styles.cardBtn}>Ver lista →</span>
        </Link>
      </div>

      <div className={styles.infoBox}>
        <h3 className={styles.infoTitle}>¿Cómo funciona el VRC?</h3>
        <div className={styles.infoGrid}>
          <div className={styles.infoStep}>
            <div className={styles.infoNum}>1</div>
            <div>
              <strong>Ingresá los datos del inmueble</strong>
              <p>Superficies, antigüedad, estado, amenities y características constructivas.</p>
            </div>
          </div>
          <div className={styles.infoStep}>
            <div className={styles.infoNum}>2</div>
            <div>
              <strong>Cargá 2 comparables</strong>
              <p>Propiedades similares publicadas en la zona con sus precios y coeficientes de ajuste.</p>
            </div>
          </div>
          <div className={styles.infoStep}>
            <div className={styles.infoNum}>3</div>
            <div>
              <strong>Calculá el VRC automáticamente</strong>
              <p>El sistema aplica la fórmula con todos los coeficientes y genera el valor de mercado.</p>
            </div>
          </div>
          <div className={styles.infoStep}>
            <div className={styles.infoNum + ' ' + styles.infoNumGreen}>4</div>
            <div>
              <strong>Descargá el informe PDF</strong>
              <p>PDF profesional listo para presentarle al propietario con portada y análisis completo.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VRCLanding;
